import { Accordion } from '@dreryk/react-components';

import { preInterviewSettingsTranslationKeys } from '../../translations';
import { StyledAccordionSectionContent } from '../HealthcareProviderPatientPortalPanel.styled';

import { PreInterviewSettingsFields } from './form/PreInterviewSettingsFields';
import { PreInterviewSettingsFormController } from './form/PreInterviewSettingsForm.types';

const t = preInterviewSettingsTranslationKeys;

type PreInterviewSettingsSectionProps = Readonly<
   Pick<PreInterviewSettingsFormController, 'register' | 'watch'> & {
      id: string;
   }
>;

export const PreInterviewSettingsSection = (props: PreInterviewSettingsSectionProps): JSX.Element => {
   return (
      <Accordion.Section id={props.id} testId={props.id} label={t.header}>
         <StyledAccordionSectionContent>
            <PreInterviewSettingsFields register={props.register} watch={props.watch} />
         </StyledAccordionSectionContent>
      </Accordion.Section>
   );
};
